<hr class="h-px w-full border-none bg-(--semantic-border-divider)" />
